import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { UserAnswer } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface UserAnswersState {
  answers: UserAnswer[];
}

// Define the initial state using that type
const initialState: UserAnswersState = {
  answers: [],
};

export const userAnswersSlice = createSlice({
  name: "userAnswers",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`

    setUserAnswers: (state, action: PayloadAction<UserAnswer[]>) => {
      state.answers = action.payload;
    },
  },
});

export const { setUserAnswers } = userAnswersSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectUserAnswersData = (state: RootState) => state.userAnswers;
export default userAnswersSlice.reducer;
